'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    cancelText: 'Cancel'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/search-bar/locale/en_US.js
// module id = 465
// module chunks = 43